import { createUseEntryPointContext } from '@atlassian/jira-entry-point/src/controllers/utils/create-use-entry-point-context/index.tsx';
import type { planIssueModal } from '@atlassian/jira-plan-issue-modal/entrypoint.tsx';

export const PlanModalEntrypointContext = createUseEntryPointContext<typeof planIssueModal>();
